import { Container, Grid, Paper} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { DateInput, Edit, SaveButton, SimpleForm, TextInput, Toolbar, useEditController, useNotify, useRedirect, useTranslate } from 'react-admin'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { ItemsTable } from '../logic/ItemsTable'
import { useFormContext, useFormState } from 'react-hook-form';

const CustomToolbar = () => {
  const { isSubmitting } = useFormState();
  const { setValue } = useFormContext();

  setValue('__externalDirty', true, {
        shouldDirty: true,
        shouldTouch: false,
    });
  return(
    <Toolbar>
        <SaveButton disabled={isSubmitting} /> 
    </Toolbar>
)};

export const SupplierPaymentOrderEdit = (props) => {
  const notify = useNotify() 
  const translate = useTranslate()
  const redirect = useRedirect()
  const { record } = useEditController({ resource: 'supplier-payment-order', id: props.id })
  const [selectedItems, setSelectedItems] = useState([])
  /* const selectedItems = record?.supplier_payment_order_item_relation.map(item=>{return {...item.item_supplier_relation, supplier_name:record?.supplier_relation.name}}) */
  const [itemsToSelect, setItemsToSelect] = useState([])
  const [originallySelectedItems, setOriginallySelectedItems] = useState([])
  const onSuccess = async (data) => {
      notify('ra.notification.updated_success_femenine', {
          type: 'success',
          messageArgs: { element: translate('ra.single_entity.supplier-payment-order') },
        })
      redirect('/supplier-payment-order')
  }

  useEffect(()=>{
    if(record){
      const initialitems = record?.supplier_payment_order_item_relation?.map(item=>{return {...item.item_supplier_relation, supplier_name:record.supplier_name, supplier_payment_order_item_id:item.id, amount_pending:item.item_supplier_relation?.amount_pending, amount:item.amount}}) ?? []
      setSelectedItems(initialitems)
      setItemsToSelect(initialitems)
      setOriginallySelectedItems(initialitems)
    }
  },[record])

  const onError = () => {
    notify('ra.notification.updated_error_femenine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.supplier-payment-order') },
    })
  }

  const onTransform = (data) => {
    return {
      ...data,
      supplier_payment_order_item_relation:itemsToSelect?.map(item=>{
        return {
          id:item.supplier_payment_order_item_id,
          item_id:item.item_id,
          pax_id:item.pax_id,
          supplier_payment_order_id:record.id,
          amount: item.amount_pending
        }
      })
    }
  }
  return (
    <Container className='content'>
        <Paper className='paper_content'>
          <Edit 
            mutationMode='pessimistic'
            transform={onTransform}
            mutationOptions={{ onSuccess, onError }}
            actions={null} title='Create Supplier Payment Order' 
            {...props}
          >
            <SimpleForm               
              toolbar={<CustomToolbar />}>
              <div>
                <Grid container>
                    <EditInputsWrap lg={6} sm={12} label={translate('ra.field.supplier')}>
                      <TextInput
                          source='supplier_relation.name'
                          fullWidth
                          disabled
                          label={false}
                      />
                    </EditInputsWrap>
                    
                </Grid>
                <Grid container>
                  <EditInputsWrap lg={6} sm={12} label={translate('ra.field.currency')}>
                      <TextInput
                          source='currency_relation.short_name'
                          fullWidth
                          label={false}
                          disabled
                      />
                    </EditInputsWrap>
                </Grid>
                <Grid container>
                    <EditInputsWrap lg={6} sm={12} label={translate('ra.field.observations')}>
                      <TextInput
                          source='observations'
                          fullWidth
                          label={false}
                      />
                    </EditInputsWrap>
                    
                </Grid>
                <Grid container>
                    <EditInputsWrap lg={6} sm={12} label={translate('ra.field.due_date')}>
                      <DateInput
                          source='due_date'
                          fullWidth
                          label={false}
                      />
                    </EditInputsWrap>
                    
                </Grid>
                  <div style={{marginTop:'15px'}}>
                    <ItemsTable title={translate('ra.title.item_selected')} supplierId={null} selectedItems={itemsToSelect} setSelectedItems={setItemsToSelect} editData={selectedItems} enableFilters={false}/>
                  </div>
                  <div style={{marginTop:'15px'}}>
                    <ItemsTable isPaymentOrder={true} title={translate('ra.title.item_total')} supplierId={record?.supplier_id} selectedItems={itemsToSelect} setSelectedItems={setItemsToSelect} originallySelectedItems={originallySelectedItems}/>
                  </div>
                </div>
            </SimpleForm>
          </Edit>
        </Paper>
      </Container>
  )
}
